import { RefObject, useEffect, useRef } from 'react';

// Invokes `handler` when a mousedown happens outside the referenced element.
// The handler is stored in a ref so the listener stays subscribed without
// requiring the caller to memoize the callback.
export function useClickOutside<T extends HTMLElement>(ref: RefObject<T>, handler: () => void, enabled = true): void {
	const handlerRef = useRef(handler);
	handlerRef.current = handler;

	useEffect(() => {
		if (!enabled) {
			return;
		}

		const listener = (event: MouseEvent) => {
			if (ref.current && !ref.current.contains(event.target as Node)) {
				handlerRef.current();
			}
		};

		document.addEventListener('mousedown', listener);
		return () => document.removeEventListener('mousedown', listener);
	}, [ref, enabled]);
}
